<div class="min-h-dvh flex items-center justify-center bg-background-light px-6">
  <div class="max-w-md w-full text-center bg-white rounded-xl shadow-card-elevated p-8">
    <a href="/" class="inline-block mb-6">
      <img ngSrc="assets/images/logo_transparent_rectangle.png" alt="corpers.ng logo" class="w-28 mx-auto" width="410" height="65" priority>
    </a>

    <ng-container *ngIf="status === 'verifying'">
      <mat-spinner class="mx-auto" diameter="40"></mat-spinner>
      <p class="mt-4 text-text-secondary">Verifying your email address...</p>
    </ng-container>

    <ng-container *ngIf="status === 'success'">
      <mat-icon class="!text-5xl !w-auto !h-auto text-primary">check_circle</mat-icon>
      <h2 class="text-2xl font-bold text-primary mt-4 mb-2">Email verified</h2>
      <p class="text-text-secondary mb-6">{{ message }}</p>
      <a routerLink="/messages" class="btn-accent">Continue</a>
    </ng-container>

    <ng-container *ngIf="status === 'error'">
      <mat-icon class="!text-5xl !w-auto !h-auto text-red-600">error</mat-icon>
      <h2 class="text-2xl font-bold text-primary mt-4 mb-2">Verification failed</h2>
      <p class="text-text-secondary mb-6">{{ message }}</p>

      <button
        *ngIf="!resendSent"
        (click)="resend()"
        [disabled]="isResending"
        class="btn-accent disabled:opacity-50"
      >
        {{ isResending ? 'Sending...' : 'Resend verification email' }}
      </button>
      <p *ngIf="resendSent" class="text-text-secondary">Check your inbox for a new verification link.</p>
    </ng-container>
  </div>
</div>
